/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Contact_DescriptionInputs */

const en_seo_contact_description = /** @type {(inputs: Seo_Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to reach the team behind Complete Athlete.`)
};

const pl_seo_contact_description = /** @type {(inputs: Seo_Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak skontaktować się z zespołem Complete Athlete.`)
};

/**
* | output |
* | --- |
* | "How to reach the team behind Complete Athlete." |
*
* @param {Seo_Contact_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_contact_description = /** @type {((inputs?: Seo_Contact_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Contact_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_contact_description(inputs)
	return en_seo_contact_description(inputs)
});